<template>
  <div class="table-container">
    <a-table class="table dataTable no-footer" :columns="visibleCloumns" :data-source="data"
      :row-selection="data.length ? rowSelection : null" :pagination="false" @change="handleTableChange">
      <template #headerCell="{ column }">
        <span draggable="true" @dragstart="dragStart(column.key)" @dragover.prevent @drop="drop(column.key)"
          style="cursor: grab; display: block; padding: 0 10px; ">
          {{ column.title }}
        </span>
      </template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'con_contract_number'">
          <!-- <router-link :to="{
            path: '/crm/edit-contract',
            query: {
              ter_Id: record.territory_id,
              org_Id: record.organization_id,
              contract_Id: record.contract_id,
            },
          }" class="profile-split d-flex flex-column">
            {{ record.con_contract_number }}
          </router-link> -->
          <router-link :to="{
            path: `/crm/edit-contract/${record.contract_id}`
          }" class="profile-split d-flex flex-column">
            {{ record.con_contract_number }}
          </router-link>
        </template>
        <template v-else-if="column.key === 'org_name'">
          <router-link :to="{
            path: '/crm/organisation-details',
            query: {
              ter_Id: record.territory_id,
              org_Id: record.organization_id,
              contract_Id: record.contract_id,
              for: 'contracts',
            },
          }" class="profile-split d-flex flex-column">
            {{ record.org_name }}
          </router-link>
        </template>

        <template v-else-if="column.key === 'action'">
          <div class="icon-field">
            <router-link :to="{
              path: `/crm/edit-contract/${record.contract_id}`
            }" class="btn table_action_btn"><i class="ti ti-edit"></i> Edit</router-link>
          </div>
        </template>
      </template>
    </a-table>
  </div>

  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handlePageTableChange" class="d-flex" />
  </div>
</template>

<script>
import apiClient from "@/axios";
import { computed, onMounted, ref, toRefs, watch, watchEffect } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    searchQuery: String,
    filterData: Object,
    date_range: String,
    columnOptions: Array,
    selectedColumns: {
      type: Array,
      default: []
    },
    moduleId: String,
  },
  data() {
    return {
      // columns,
      data: [],
      selectedUserId: null,
      showDeleteModal: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      rowSelection: {
        onChange: () => { },
        onSelect: () => { },
        onSelectAll: () => { },
      },
    };
  },

  setup(props) {
    const store = useStore();
    const data = ref([]);
    const column = ref([]);
    const module_data = ref([]);
    const { moduleId } = toRefs(props);
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    const sorter = ref({
      key: "", // Default sort key
      order: "", // Default order
    });
    let draggedColumnKey = null;
    const visibleCloumns = ref([])

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const dragStart = (key) => {
      draggedColumnKey = key;
    };
    const drop = (targetKey) => {
      if (draggedColumnKey !== targetKey) {
        const oldIndex = visibleCloumns.value.findIndex((col) => col.key === draggedColumnKey);
        const newIndex = visibleCloumns.value.findIndex((col) => col.key === targetKey);
        const movedColumn = visibleCloumns.value.splice(oldIndex, 1)[0];
        visibleCloumns.value.splice(newIndex, 0, movedColumn);
        saveFieldOrder();
      }
    };

    const fetchContracts = async (page) => {
      console.log("props.filterData?.cm_responsible",props.filterData?.cm_responsible)
      if (typeof page === 'number' && Number.isFinite(page)) {
        pagination.value.current = page;
      }
      const params = {
        search: props.searchQuery, // Use the correct prop
        page: pagination.value.current,
        pageSize: pagination.value.pageSize,
        sort_field: sorter.value.key,
        sort_order: sorter.value.order,
        date_range: props.date_range,
        cm_responsible: props.filterData?.cm_responsible,
        // sales_responsible: props.filterData?.sales_responsible,
        u4b_status: props.filterData?.u4b_status,
      };

      const response = await store.dispatch("contract/fetchContracts", params);
      if (response.data.status) {
        // data.value = response.data.data.contracts.map((fields) => {
        //   return fields.fields;
        // });

        data.value = response.data.data.contracts.map((item) => {
          const formattedFields = {}

          for (const [key, value] of Object.entries(item.fields)) {
            if (typeof value === 'string' && value.trim() !== '') {
              if (value === value.toLowerCase()) {
                // Only convert if value is all lowercase
                formattedFields[key] = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
              } else {
                formattedFields[key] = value // leave as is
              }
            } else {
              formattedFields[key] = value // preserve null, numbers, etc.
            }
          }

          return formattedFields
        })

        if (
          props.selectedColumns?.length === 0 &&
          props.selectedColumns?.value?.length === undefined
        ) {
          await fetchModuleData(props.moduleId);
        }

        // await fetchModuleData(props.moduleId)

        let dynamicColumns = [];

        if (module_data.value.length > 0) {
          module_data.value.map((org) => {
            return org.children.map((item) => {
              const label = org.label.charAt(0).toUpperCase() + org.label.substr(1, 2);
              const itemLabel = item.label.charAt(0).toUpperCase() + item.label.substr(1);

              dynamicColumns.push({
                label: `${org.label.charAt(0).toUpperCase() + org.label.substr(1)}: ${item.label.charAt(0).toUpperCase() + item.label.substr(1)
                  }`,
                title: `${label}. ${itemLabel}`,
                field: item.field,
                dataIndex: item.field,
                key: item.field,
                sorter: (a, b) => {
                  const aValue = a[item.field];
                  const bValue = b[item.field];

                  if (!aValue || !bValue) return 0;

                  // Numeric sort
                  if (!isNaN(aValue) && !isNaN(bValue)) {
                    return Number(aValue) - Number(bValue);
                  }

                  const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
                  const ddMmYyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;

                  if (isoDateRegex.test(aValue) && isoDateRegex.test(bValue)) {
                    return new Date(aValue).getTime() - new Date(bValue).getTime();
                  }

                  if (ddMmYyyyRegex.test(aValue) && ddMmYyyyRegex.test(bValue)) {
                    const parseDate = (dateStr) => {
                      const [day, month, year] = dateStr.split('/').map(Number);
                      return new Date(year, month - 1, day);
                    };

                    return parseDate(aValue).getTime() - parseDate(bValue).getTime();
                  }

                  // Default string sort
                  return aValue.toString().localeCompare(bValue.toString());
                }

              });
            });
          });

          // Add the Action column at the end
          dynamicColumns.push({
            title: "Action",
            label: "Action",
            dataIndex: "Action",
            key: "action",
            // fixed: "right", width: 200
          });

          column.value = dynamicColumns;

          const columnKeys = [
            "con_contract_number",
            "org_name",
            "opp_cm_responsible",
            "opp_sales_responsible",
            "con_u4b_status",
            "opp_date_of_sale",
            "opp_sc_forecast_or_amended_annual_consumption",
          ];

          // Separate columns based on columnKeys
          const prioritizedColumns = columnKeys
            .map((key) => dynamicColumns.find((col) => col.key === key))
            .filter(Boolean); // Remove undefined values if any key is not found
          const otherColumns = dynamicColumns.filter(
            (col) => !columnKeys.includes(col.key)
          );

          // Merge prioritized columns first, then others
          const orderedColumns = [...prioritizedColumns, ...otherColumns];

          // Assign the ordered columns to columnOptions
          props.columnOptions.value = orderedColumns
            .filter((col) => col.key !== "action") // Exclude 'action' column
            .map((col) => ({
              label: col.label,
              value: col.key,
            }));

          if (
            props.selectedColumns?.length === 0 && visibleCloumns.value.length === 0 &&
            props.selectedColumns?.value?.length === undefined
          ) {
            props.selectedColumns.value = props.columnOptions.value
              .slice(0, 6)
              .map((option) => option.value);
          } else {
            props.selectedColumns.value = visibleCloumns.value
              .map((option) => option.key);
          }
        }

        pagination.value.total = response.data.data.total;
      }
    };

    // const filteredColumns = computed(() => {
    //   // Filter selected columns
    //   let selectedCols =
    //     props.selectedColumns.value?.length === 0
    //       ? column.value
    //       : props.selectedColumns.value
    //         ?.map((key) => column.value.find((col) => col.key === key))
    //         ?.filter(Boolean); // Removes undefined values in case any key is missing

    //   // Ensure "Action" column is always included
    //   if (!selectedCols?.some((col) => col.key === "action")) {
    //     const actionColumn = column.value.find((col) => col.key === "action");
    //     if (actionColumn) {
    //       selectedCols.push(actionColumn);
    //     }
    //   }

    //   visibleCloumns.value = selectedCols;

    //   return selectedCols;
    // });

    // watch(
    //   () => props.selectedColumns.value,
    //   (newVal) => {
    //     let selectedCols =
    //       !newVal || newVal.length === 0
    //         ? column.value
    //         : newVal
    //           .map((key) => column.value.find((col) => col.key === key))
    //           .filter(Boolean);

    //     if (!selectedCols.some((col) => col.key === "action")) {
    //       const actionColumn = column.value.find((col) => col.key === "action");
    //       if (actionColumn) {
    //         selectedCols.push(actionColumn);
    //       }
    //     }
    //     if (visibleCloumns.value.length > 0) {
    //       const visibleKeys = visibleCloumns.value.map(col => col.key);

    //       const remainingColumns = selectedCols.filter(
    //         col => !visibleKeys.includes(col.key)
    //       );

    //       visibleCloumns.value = [...visibleCloumns.value, ...remainingColumns];
    //     } else {
    //       visibleCloumns.value = selectedCols;
    //     }
    //   },
    //   { immediate: true, deep: true }
    // );

    const saveFieldOrder = async () => {
      const payload = {
        form_key: 'contract_listing',
        fields_json: visibleCloumns.value
      }
      const response = await store.dispatch("opportunity/changeColumns", payload)
    };

    watch(
      () => props.selectedColumns.value,
      (newVal, oldProps) => {
        let selectedCols =
          !newVal || newVal.length === 0
            ? column.value
            : newVal
              .map((key) => column.value.find((col) => col.key === key))
              .filter(Boolean);

        // Ensure the "action" column is included
        const actionColumn = column.value.find((col) => col.key === "action");
        if (!selectedCols.some((col) => col.key === "action") && actionColumn) {
          selectedCols.push(actionColumn);
        }


        if (visibleCloumns.value.length > 0) {
          // const actionKey = "action";

          // Separate action column if already in visibleCloumns
          // const visibleWithoutAction = selectedCols.filter(col => col.key !== actionKey);

          // Combine and make sure action column is at the end
          // visibleCloumns.value = [...selectedCols];

          // const currentKeys = visibleCloumns.value.map(col => col.key);
          // const extraCols = selectedCols.filter(col => !currentKeys.includes(col.key));

          // Append extra columns to visibleCloumns.value
          // visibleCloumns.value = [...visibleCloumns.value, ...extraCols];

          // if (actionColumn) {
          //   visibleCloumns.value.push(actionColumn);
          // }

          const selectedKeys = new Set(selectedCols.map(col => col.key));

          // Remove columns not in selectedCols (except "action")
          visibleCloumns.value = visibleCloumns.value.filter(
            col => selectedKeys.has(col.key) || col.key === "action"
          );

          // Add missing columns at the end
          const visibleKeys = new Set(visibleCloumns.value.map(col => col.key));
          const newExtraCols = selectedCols.filter(col => !visibleKeys.has(col.key));

          visibleCloumns.value.push(...newExtraCols);

          if(oldProps){
            saveFieldOrder();
          }

        }
        else {
          // If no visible columns yet, set from selectedCols, move action to end
          // visibleCloumns.value = selectedCols.filter(col => col.key !== "action");
          // if (actionColumn) {
          //   visibleCloumns.value.push(actionColumn);
          // }
          visibleCloumns.value = [...selectedCols];
        }
      },
      { immediate: true, deep: true }
    );

    const fetchModuleData = async (id) => {
      try {
        // const data = await store.dispatch("report/fetchModuleData", id);
        const response = await apiClient.get(`/report/module/${id}/fields?type=filters`);
        if (response.data.status) {
          module_data.value = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
      }
    };

    // Function to convert date format
    const formatDate = (date) => {
      if (date) {
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      }
    };
    const handlePageTableChange = (current, pageSize, sort) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      // if (sort?.order) {
      //   sorter.value.key = sort.columnKey;
      //   sorter.value.order =
      //     sort.order === "ascend" ? "ASC" : sort.order === "descend" ? "DESC" : "";
      // } else {
      //   sorter.value.key = '';
      //   sorter.value.order = "";
      // }

      fetchContracts();
    };

    const handleTableChange = (page, filters, sort) => {
      // pagination.value.current = Number(page.current) || 1;
      // pagination.value.pageSize = Number(page.pageSize) || 10;
      if (sort?.order) {
        sorter.value.key = sort.columnKey;
        sorter.value.order =
          sort.order === "ascend" ? "ASC" : sort.order === "descend" ? "DESC" : "";
      } else {
        sorter.value.key = '';
        sorter.value.order = "";
      }

      fetchContracts();
    };

    const fetchColumns = async () => {
      const res = await store.dispatch("opportunity/getColumnsData", 'contract_listing');
      if (res.data && Object.keys(res.data).length > 0) {
        const fields = res.data.fields_json;

        visibleCloumns.value = fields.map(item => ({
          ...item,
          sorter: (a, b) => {
            const aValue = a[item.field];
            const bValue = b[item.field];

            if (!aValue || !bValue) return 0;

            // Check if value is a valid number
            if (!isNaN(aValue) && !isNaN(bValue)) {
              return Number(aValue) - Number(bValue);
            }

            const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
            const ddMmYyyyRegex = /^\d{2}\/\d{2}\/\d{4}$/;

            if (isoDateRegex.test(aValue) && isoDateRegex.test(bValue)) {
              return new Date(aValue).getTime() - new Date(bValue).getTime();
            }

            if (ddMmYyyyRegex.test(aValue) && ddMmYyyyRegex.test(bValue)) {
              const parseDate = (dateStr) => {
                const [day, month, year] = dateStr.split('/').map(Number);
                return new Date(year, month - 1, day);
              };

              return parseDate(aValue).getTime() - parseDate(bValue).getTime();
            }
            // Default to string sorting
            return aValue.toString().localeCompare(bValue.toString());
          }
        }));
      }
    };


    onMounted(async () => {
      await fetchColumns()
    })

    return {
      data,
      pagination,
      formatDate,
      fetchContracts,
      handleTableChange,
      handlePageTableChange,
      dragStart,
      drop,
      column,
      // filteredColumns,
      fetchModuleData,
      module_data,
      sorter,
      pageSizeOptions,
      visibleCloumns,
      saveFieldOrder,
      fetchColumns,
    };
  },
};
</script>
